import styled from "styled-components";

import Grid from "../Hedron";

export default styled(Grid.Bounds).attrs({
  direction: "horizontal",
  wrap: 1
})`
  width: 100%;
  flex-wrap: wrap;
`;
